"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _TargetGrant_1 = require("./_TargetGrant");
exports._TargetGrants = {
    type: "list",
    member: {
        shape: _TargetGrant_1._TargetGrant,
        locationName: "Grant"
    }
};
//# sourceMappingURL=_TargetGrants.js.map